// validateEmail 
export const validateEmail = (email: string) => {
    if (email.length < 1) return false;

    let validEmail = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,10}$/;

    if (!validEmail.test(email)) return false;

    return true;
}

export const getEmailErrorMessage = (email: string) => {
    if (email.length < 1) return 'Campo obligatorio';

    let validEmail = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,10}$/;

    if (!validEmail.test(email)) return 'Ingrese un correo válido.';

    return null;
}

// validatePassword
export const validatePassword = (password: string) => {
    if (password.length < 1) return false;

    if (password.length < 8) return false;

    return true;
}

export const getPasswordErrorMessage = (password: string) => {
    if (password.length < 1) return 'Campo obligatorio';

    if (password.length < 8) return 'La contraseña debe tener una longitud de 8 caracteres como mínimo.';

    return null;
}

export const validateCardCode = (value: string) => {
    if (value.length < 1) return false;

    let validCardCode = /^CL\d{5}$/;

    if (!validCardCode.test(value)) return false;

    return true;
}

export const getCardCodeErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    let validCardCode = /^CL\d{5}$/;

    if (!validCardCode.test(value)) return 'El formato del código de cliente debe ser "CL" seguido de 5 dígitos';

    return null;
}

export const validateCardFName = (value: string) => {
    if (value.length < 1) return false;

    if (value.length < 3) return false;

    return true;
}

export const getCardFNameErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    if (value.length < 3) return 'Ingrese una razón social válida';

    return null; 
}

export const validateCardName = (value: string) => {
    if (value.length < 1) return false;

    if (value.length < 10) return false;

    return true;
}

export const getCardNameErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    if (value.length < 10) return 'Ingrese un nombre de contribuyente válido';

    return null; 
}

export const validateNit = (value: string) => {
    if (value.length < 1) return false;

    if (value.length !== 9 && value.length !== 14) return false;

    return true;
}

export const getNitErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    if (value.length !== 9 && value.length !== 14) return 'El N.I.T. debe contener 14 dígitos. En el caso de utilizar el número de D.U.I. este debe tener 9 dígitos'

    return true;
}

// Función para validar el nit en el formulario de edición de tarjetas de IVA
export const validateNitIvaCard = (value: string) => {
    if (value.length < 1) return false;

    if (value.length < 9) return false;

    return true;
}

export const getNitIvaCardErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    if (value.length < 9) return 'El N.I.T debe contener por lo menos 9 dígitos'

    return true;
}

export const validateNrc = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getNrcErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

// Función para validar el nit en el formulario de edición de tarjetas de IVA
export const validateNrcIvaCards = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getNrcIvaCardsErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

export const validateEconomicActivity = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getEconomicActivityErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

export const validateAddress = (value: string) => {
    if (value.length < 1) return false;

    if (value.length < 12) return false;

    return true;
}

export const getAddressErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    if (value.length < 12) return 'Ingrese una dirección válida';

    return null;
}

export const validateDepartment = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getDepartmentErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

export const validateMunicipality  = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getMunicipalityErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

export const validateDistrict  = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getDistrictErrorMessage = (value: string) => {
    if (value.length < 1) return 'Campo obligatorio';

    return null;
}

export const validateContactPerson = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getContactPersonErrorMessage = (value: string) => {
    if (value.length < 1) return "Campo obligatorio";

    return null;
}

export const validateContactPhone = (value: string) => {
    if (value.length < 1) return false;

    if (value.length < 8) return false;

    return true;
}

export const getContactPhoneErrorMessage = (value: string) => {
    if (value.length < 1) return "Campo obligatorio";

    if (value.length < 8) return "Ingrese un número de contacto válido";

    return null;
}

export const validateBusinessType = (value: string) => {
    if (value.length < 1) return false;

    return true;
}

export const getBusinessTypeErrorMessage = (value: string) => {
    if (value.length < 1) return "Campo obligatorio";

    return null;
}